module.exports = __webpack_public_path__ + "img/oeko.0681be61.jpg";